import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../axiosInstance";
import logoBanner from "../assets/images/new_logo_without_font.png";
import heroDashboard from '../assets/images/prmo.png';
import iconBTC from "../assets/images/bitcoin.png";
import iconETH from "../assets/images/eth.png";
import iconSOL from "../assets/images/solana.png";
import iconWAV from "../assets/images/Waves.png";


export default function LandingPage() {
  const [users, setUsers] = useState(0);
  const [coinz, setCoinz] = useState(0);
  const [dividends, setDividends] = useState(0);

  const formatCoinz = (value) => value.toLocaleString("en-US");

  const fetchStats = async () => {
    try {
      const response = await axios.get("/api/stats");
      const { users, coinz, dividends } = response.data;
      setUsers(users);
      setCoinz(coinz);
      setDividends(dividends);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-white overflow-x-hidden relative pb-20">
      {/* Header */}
      <header className="border-b border-gray-800 px-4 sm:px-6 py-4 flex items-center justify-between">
        <Link to="/">
          <img src={logoBanner} alt="CoinZUp Logo" className="w-32 sm:w-40 h-auto" />
        </Link>
        <div className="space-x-3 sm:space-x-4 text-sm sm:text-base">
          <Link to="/blog" className="hover:underline">Blog</Link>
          <Link to="/login" className="hover:underline">Log In</Link>
          <Link to="/register" className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition">
            Sign Up
          </Link>
        </div>
      </header>

      {/* Hero Section with Live Stats */}
      <section className="text-center py-16 px-4 sm:px-6 lg:px-8 bg-gray-950 border-b border-yellow-500">
        <div className="max-w-5xl mx-auto">
          <h1 className="text-3xl sm:text-5xl font-extrabold text-white mb-4">
            Get Daily crypto Rewards — No Mining, No Investment. 
          </h1>
          <p className="text-gray-300 mb-8 text-lg sm:text-xl">
            Join <span className="text-yellow-400 font-bold">{users.toLocaleString()}</span> crypto enthusiasts already earning daily rewards.
          </p>

          {/* Stats Inline */}
          <div className="flex flex-wrap justify-center gap-6 mb-8">
            <div className="text-center">
              <p className="text-2xl font-bold text-yellow-400">{users.toLocaleString()}</p>
              <p className="text-gray-400 text-sm">Registered Users</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-yellow-400">${formatCoinz(Number(coinz/100000))} </p>
              <p className="text-gray-400 text-sm">$ Distributed</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-yellow-400">${(dividends / 100000).toFixed(2)}</p>
              <p className="text-gray-400 text-sm">Dividends Paid</p>
            </div>
          </div>

          <Link to="/register" className="bg-yellow-500 text-black px-8 py-4 rounded-full text-lg font-semibold hover:bg-yellow-400 transition">
            🎁 Claim 50,000 COINZ Now
          </Link>

          <p className="text-gray-500 text-sm mt-4">100% free · No KYC · Quick Withdrawals</p>
        </div>
      </section>

      {/* Hero Image */}
      <section className="bg-gray-950 py-12 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl sm:text-4xl font-bold mb-4">
              Start earning passive Bitcoin in minutes
            </h2>
            <p className="text-gray-400 mb-6 text-lg">
              Earn COINZ daily by surfing, claiming hourly draws and staking your rewards with investing in options for weekly payouts.
            </p>
            <Link to="/register" className="bg-yellow-500 text-black px-8 py-4 rounded-full text-lg font-semibold hover:bg-yellow-400 transition">
              Join & Start Earning
            </Link>
          </div>
          <div className="flex-1 flex justify-center">
            <img
              src={heroDashboard}
              alt="CoinZUp Dashboard Preview"
              className="w-full max-w-md rounded-xl shadow-lg border border-gray-700"
            />
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section className="px-4 sm:px-6 py-14 bg-gray-900 border-y border-yellow-500">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-center">
          <div className="bg-gray-800 p-6 rounded-lg shadow">
            <h3 className="text-lg sm:text-xl font-semibold mb-2"> Daily Free Rewards</h3>
            <p className="text-gray-400 text-sm">Hourly draws, daily bonuses and instant COINZ to boost your balance.</p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow">
            <h3 className="text-lg sm:text-xl font-semibold mb-2"> Weekly Bitcoin Payouts</h3>
            <p className="text-gray-400 text-sm">Convert COINZ to BTC and withdraw every week—no fees, no hassle.</p>
          </div>
          <div className="bg-gray-800 p-6 rounded-lg shadow">
            <h3 className="text-lg sm:text-xl font-semibold mb-2"> Earn More with Referrals</h3>
            <p className="text-gray-400 text-sm">Invite friends and earn lifetime commissions on their earnings.</p>
          </div>
        </div>
      </section>

      {/* Referral CTA */}
      <section className="text-center px-4 sm:px-6 py-16 bg-gray-950">
        <h2 className="text-3xl font-bold mb-4">Earn More by Growing Your Network</h2>
        <p className="text-gray-400 max-w-xl mx-auto mb-6 text-lg">
          Share your unique link, grow your team, and receive passive income as your network expands.
        </p>
        <Link to="/register" className="bg-green-500 text-black px-8 py-4 rounded-full text-lg font-semibold hover:bg-green-400 transition">
          Get My Referral Link
        </Link>
      </section>

      {/* Supported Withdrawals */}
<section className="px-4 sm:px-6 py-16 bg-gray-950 text-center border-t border-gray-800">
  <h2 className="text-3xl font-bold mb-6 text-white">Withdraw Your Rewards in Crypto</h2>
  <p className="text-gray-400 max-w-2xl mx-auto mb-10 text-lg">
    CoinZUp lets you withdraw your COINZ in real cryptocurrencies every week — no fees, no delays.
  </p>
  <div className="max-w-4xl mx-auto grid grid-cols-2 sm:grid-cols-4 gap-6">
    <div className="bg-gray-900 p-4 rounded-lg border border-gray-800">
      <img src={iconBTC} alt="BTC" className="w-10 h-10 mx-auto mb-2" />
      <h3 className="text-yellow-400 font-bold">Bitcoin (BTC)</h3>
      <p className="text-sm text-gray-400">Fast & global payouts.</p>
    </div>
    <div className="bg-gray-900 p-4 rounded-lg border border-gray-800">
      <img src={iconETH} alt="ETH" className="w-10 h-10 mx-auto mb-2" />
      <h3 className="text-yellow-400 font-bold">Ethereum (ETH)</h3>
      <p className="text-sm text-gray-400">Withdraw via ERC-20.</p>
    </div>
    <div className="bg-gray-900 p-4 rounded-lg border border-gray-800">
      <img src={iconSOL} alt="SOL" className="w-10 h-10 mx-auto mb-2" />
      <h3 className="text-yellow-400 font-bold">Solana (SOL)</h3>
      <p className="text-sm text-gray-400">Low fees & fast network.</p>
    </div>
    <div className="bg-gray-900 p-4 rounded-lg border border-gray-800">
      <img src={iconWAV} alt="WAVES" className="w-10 h-10 mx-auto mb-2" />
      <h3 className="text-yellow-400 font-bold">Waves (WAVES)</h3>
      <p className="text-sm text-gray-400">Simple and instant.</p>
    </div>
  </div>
</section>

      {/* Footer */}
      <footer className="bg-gray-900 text-center text-sm text-gray-500 py-4 border-t border-gray-800 space-x-2">
        © 2025 CoinZUp.net. All rights reserved.
        <Link to="/notice" className="hover:text-white underline">Privacy & Legal Notice</Link>
        <Link to="/terms" className="hover:text-white underline">Terms & Conditions</Link>
      </footer>

      {/* Mobile Sticky CTA */}
      <div className="fixed bottom-0 left-0 right-0 bg-yellow-500 text-black text-center py-3 sm:hidden z-50 shadow-md">
        <Link to="/register" className="font-semibold text-base">
          🎁 Claim 50,000 COINZ Now →
        </Link>
      </div>
    </div>
  );
}
